import { UserApi } from './endpoints/user';
import { GameApi } from './endpoints/game';
import { PayApi } from './endpoints/pay';

import { ApiConfig } from '../../types/api';

export class ApiManager {
  private static instance: ApiManager | null = null;
  private userApi: UserApi;
  private gameApi: GameApi;
  private payApi: PayApi;

  private constructor(config: ApiConfig) {
    this.userApi = new UserApi(config);
    this.gameApi = new GameApi(config);
    this.payApi = new PayApi(config);
  }

  static getInstance(): ApiManager {
    if (!ApiManager.instance) {
      ApiManager.instance = new ApiManager({});
    }
    return ApiManager.instance;
  }

  static setConfig(config: ApiConfig): void {
    ApiManager.instance = new ApiManager(config);
  }

  updataConfig (config: ApiConfig): void {
    this.gameApi.updateConfig(config);
    this.userApi.updateConfig(config);
    this.payApi.updateConfig(config);
  }

  get user(): UserApi {
    return this.userApi;
  }

  get game(): GameApi {
    return this.gameApi;
  }

  get pay(): PayApi {
    return this.payApi;
  }
}

export default ApiManager;